/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreamingMode } from './StreamingMode';
import {
    StreamingModeFromJSON,
    StreamingModeFromJSONTyped,
    StreamingModeToJSON,
    StreamingModeToJSONTyped,
} from './StreamingMode';
import type { FeaturedStream } from './FeaturedStream';
import {
    FeaturedStreamFromJSON,
    FeaturedStreamFromJSONTyped,
    FeaturedStreamToJSON,
    FeaturedStreamToJSONTyped,
} from './FeaturedStream';

/**
 * Competition-level streaming configuration
 * @export
 * @interface StreamingSettings
 */
export interface StreamingSettings {
    /**
     * Master toggle for streaming features
     * @type {boolean}
     * @memberof StreamingSettings
     */
    enabled?: boolean;
    /**
     * Allow users to declare their streams
     * @type {boolean}
     * @memberof StreamingSettings
     */
    allowParticipantStreams?: boolean;
    /**
     * Show in DevourPlay Live discovery
     * @type {boolean}
     * @memberof StreamingSettings
     */
    discoverableInLiveHub?: boolean;
    /**
     * Require admin approval for participant streams
     * @type {boolean}
     * @memberof StreamingSettings
     */
    requireApproval?: boolean;
    /**
     * Display viewer counts publicly
     * @type {boolean}
     * @memberof StreamingSettings
     */
    showViewerCounts?: boolean;
    /**
     * Maximum number of featured streams
     * @type {number}
     * @memberof StreamingSettings
     */
    maxFeaturedStreams?: number;
    /**
     * 
     * @type {StreamingMode}
     * @memberof StreamingSettings
     */
    streamingMode?: StreamingMode;
    /**
     * 
     * @type {Array<FeaturedStream>}
     * @memberof StreamingSettings
     */
    featuredStreams?: Array<FeaturedStream>;
}



/**
 * Check if a given object implements the StreamingSettings interface.
 */
export function instanceOfStreamingSettings(value: object): value is StreamingSettings {
    return true;
}

export function StreamingSettingsFromJSON(json: any): StreamingSettings {
    return StreamingSettingsFromJSONTyped(json, false);
}

export function StreamingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'allowParticipantStreams': json['allowParticipantStreams'] == null ? undefined : json['allowParticipantStreams'],
        'discoverableInLiveHub': json['discoverableInLiveHub'] == null ? undefined : json['discoverableInLiveHub'],
        'requireApproval': json['requireApproval'] == null ? undefined : json['requireApproval'],
        'showViewerCounts': json['showViewerCounts'] == null ? undefined : json['showViewerCounts'],
        'maxFeaturedStreams': json['maxFeaturedStreams'] == null ? undefined : json['maxFeaturedStreams'],
        'streamingMode': json['streamingMode'] == null ? undefined : StreamingModeFromJSON(json['streamingMode']),
        'featuredStreams': json['featuredStreams'] == null ? undefined : ((json['featuredStreams'] as Array<any>).map(FeaturedStreamFromJSON)),
    };
}

export function StreamingSettingsToJSON(json: any): StreamingSettings {
    return StreamingSettingsToJSONTyped(json, false);
}

export function StreamingSettingsToJSONTyped(value?: StreamingSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'allowParticipantStreams': value['allowParticipantStreams'],
        'discoverableInLiveHub': value['discoverableInLiveHub'],
        'requireApproval': value['requireApproval'],
        'showViewerCounts': value['showViewerCounts'],
        'maxFeaturedStreams': value['maxFeaturedStreams'],
        'streamingMode': StreamingModeToJSON(value['streamingMode']),
        'featuredStreams': value['featuredStreams'] == null ? undefined : ((value['featuredStreams'] as Array<any>).map(FeaturedStreamToJSON)),
    };
}

